import { authAPI } from '@/api/auth';
import storage from '@/utils/storage';

export default {
  namespaced: true,
  state: {
    user: null,
    token: null,
    isAuthenticated: false,
    loading: false,
    error: null
  },
  getters: {
    user: (state) => state.user,
    isAuthenticated: (state) => state.isAuthenticated,
    isLoading: (state) => state.loading,
    error: (state) => state.error,
    userRole: (state) => state.user?.role || 'user'
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
      if (user) {
        storage.set('user', user);
      } else {
        storage.remove('user');
      }
    },
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        storage.set('token', token);
      } else {
        storage.remove('token');
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ERROR(state) {
      state.error = null;
    }
  },
  actions: {
    async login({ commit }, credentials) {
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');
      try {
        const response = await authAPI.login(credentials);
        const { user, tokens } = response.data;
        
        commit('SET_USER', user);
        commit('SET_TOKEN', tokens.access);
        
        return user;
      } catch (error) {
        const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Login failed';
        commit('SET_ERROR', errorMessage);
        throw new Error(errorMessage);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async register({ commit }, userData) {
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');
      try {
        const response = await authAPI.register(userData);
        const { data } = response.data;
        
        // After registration, we need to login automatically
        const loginResponse = await authAPI.login({
          email: userData.email,
          password: userData.password
        });
        
        const { user, tokens } = loginResponse.data;
        
        commit('SET_USER', user);
        commit('SET_TOKEN', tokens.access);
        
        return user;
      } catch (error) {
        const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Registration failed';
        commit('SET_ERROR', errorMessage);
        throw new Error(errorMessage);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async logout({ commit }) {
      try {
        await authAPI.logout();
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        commit('SET_USER', null);
        commit('SET_TOKEN', null);
      }
    },
    
    async restoreSession({ commit }) {
      const user = storage.get('user');
      const token = storage.get('token');
      if (user && token) {
        commit('SET_USER', user);
        commit('SET_TOKEN', token);
        
        // Verify token is still valid
        try {
          await authAPI.getProfile();
        } catch (error) {
          // Token expired
          commit('SET_USER', null);
          commit('SET_TOKEN', null);
        }
      }
    }
  }
};